<template>
  <div class="min-h-0 flex-1 overflow-auto bg-gray-50 p-4 dark:bg-slate-800">
    <ActivityTable :activities="companyActivity ?? []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheCompanyActivityPage',
  computed: {
    ...mapGetters({ companyActivity: 'company/getCompanyActivity' })
  },
  methods: {
    ...mapActions({ fetch: 'company/fetchCompanyActivitiesByCompanyID' })
  },
  beforeMount() {
    this.fetch({ company_id: this.$route.params.id })
  }
}
</script>
